import React from 'react'
import {
  makeStyles,
  InputLabel,
  MenuItem,
  FormControl,
  TextField
} from '@material-ui/core'
import { t as i18n } from 'ttag'

const LinkItems = [
  {
    value: '01',
    label: 'RFG Phoenix Arizona '
  },
  {
    value: '02',
    label: 'RFG London'
  },
  {
    value: '03',
    label: 'RFG Hong Kong'
  },
  {
    value: '04',
    label: 'RFG Panama'
  }
]

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline',
    flexWrap: 'wrap'
  },
  linkSelect: {
    width: 150,
    marginRight: theme.spacing(1)
  },
  search: {
    width: 450,
    marginRight: theme.spacing(1)
  }
}))

const LinkSelect = () => {
  const classes = useStyles()
  const [linkTo, setLinkTo] = React.useState('')
  const handleChange = event => {
    setLinkTo(event.target.value)
  }
  return (
    <form className={classes.root} autoComplete='off'>
      <FormControl className={classes.linkSelect}>
        <InputLabel htmlFor='customized-select'> </InputLabel>
        <TextField
          variant='outlined'
          select
          label={i18n`Link to`}
          value={linkTo}
          onChange={handleChange}
          input={<TextField name='linkTo' id='customized-select' />}
        >
          {LinkItems.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
    </form>
  )
}

export default LinkSelect
